// location.search
import React from 'react'

export const AuthorizationView = () => {
    console.debug('AuthorizationView')
    return <div>Hello World</div>
}
